import { IAttendanceDashboardData } from 'src/apis/dashboard/dashboardAttendance.interfaces';

export const dashboardAttendanceMock: IAttendanceDashboardData = {
  summary: {
    totalCount: 100,
    totalPercentage: 100,
    expectedCount: 100,
  },
  status: {
    present: 100,
    absent: 10,
    leave: 10,
    holiday: 10,
  },
  period: {
    startDate: '2024-01-01',
    endDate: '2024-12-31',
  },
  timeSeries: [
    {
      date: '2024-01-01',
      present: 100,
      absent: 10,
      leave: 10,
      holiday: 10,
      total: 100,
      percentage: 100,
    },
    {
      date: '2024-01-02',
      present: 100,
      absent: 10,
      leave: 10,
      holiday: 10,
      total: 100,
      percentage: 100,
    },
    {
      date: '2024-01-03',
      present: 100,
      absent: 10,
      leave: 10,
      holiday: 10,
      total: 100,
      percentage: 100,
    },
    {
      date: '2024-01-04',
      present: 100,
      absent: 10,
      leave: 10,
      holiday: 10,
      total: 100,
      percentage: 100,
    },
  ],
  breakdown: {
    students: {
      present: 100,
      absent: 10,
      leave: 10,
      holiday: 10,
    },
    staff: {
      present: 100,
      absent: 10,
      leave: 10,
      holiday: 10,
    },
    byClass: {
      '1A': {
        present: 100,
        absent: 10,
        leave: 10,
        holiday: 10,
        className: '1A',
      },
      '1B': {
        present: 100,
        absent: 10,
        leave: 10,
        holiday: 10,
        className: '1B',
      },
      '1C': {
        present: 100,
        absent: 10,
        leave: 10,
        holiday: 10,
        className: '1C',
      },
    },
    byDepartment: {
      present: 100,
      absent: 10,
      leave: 10,
      holiday: 10,
    },
  },
};
